import React from "react";
import { Box, Circle, Divider, FlatList, HStack, Icon, Image, Text, VStack } from "native-base";
import AppStore from "AppStore";
import colors from "config/colors";
import { Ionicons, MaterialCommunityIcons, MaterialIcons } from "assets/icons";
import { Linking, Platform, TouchableOpacity } from "react-native";
import { mitraCalled } from "../healthcare-mitra/actions";

const MitrasList = ({ mitras, handlePagination, listHeaderComponent, listFooterComponent }: any) => {
  const [isBigScreen] = AppStore("isBigScreen");
  const [user] = AppStore("user");
  const [isOpen, setIsOpen] = AppStore("isOpen");
  const [isLoading, setIsLoading] = AppStore("isLoading");

  const handleCall = (mitraId: any, phone: any) => {
    setIsLoading(true);
    mitraCalled(user, mitraId, (res: any, err: any) => {
      if (!err && res.data) {
        setIsLoading(false);
        Linking.openURL(`tel:${phone}`);
      } else {
        setIsLoading(false);
      }
    });
  };

  return (
    <FlatList
      data={mitras}
      showsVerticalScrollIndicator={false}
      numColumns={isBigScreen ? 2 : 1}
      onEndReached={Platform.OS == "web" ? () => {} : handlePagination}
      onEndReachedThreshold={0.5}
      ListHeaderComponent={listHeaderComponent}
      ListFooterComponent={listFooterComponent}
      renderItem={({ item }: any) => {
        return (
          <Box
            w={isBigScreen ? 600 : "full"}
            borderRadius="2xl"
            borderWidth="1"
            borderColor={isBigScreen ? colors.webBorder : colors.phoneBorder}
            backgroundColor="white"
            py="4"
            my="2"
            mx={isBigScreen ? 1 : 0}
            flex={!isBigScreen ? "1" : isBigScreen ? (item.length % 2 == 0 ? "1" : "1/2") : null}
            justifyContent="center"
          >
            <HStack alignItems="center">
              <Box flex="1" overflow="hidden" alignItems="center" justifyContent="center" p="1">
                <Image size={65} source={require("assets/images/no-profile.png")} alt="loading" resizeMode="contain" />
              </Box>
              <VStack space="1" flex="3">
                <Text fontSize="md" fontWeight="medium" noOfLines={2} lineHeight="sm">
                  {item.name}
                </Text>

                <HStack alignItems="center" space="1" flexWrap="wrap">
                  <Circle bg="gray.200" size="5">
                    <Icon size="3" color={colors.darkGrayish} as={<Ionicons name="ios-location-sharp" />} />
                  </Circle>
                  <Text fontSize="sm" fontWeight="medium" color="coolGray.500">
                    {item.address}
                  </Text>
                </HStack>
              </VStack>
              <Divider orientation="vertical" />
              <VStack alignItems="center" space="3" flex="1">
                {item.phone_no ? (
                  <TouchableOpacity
                    onPress={() => (Object.keys(user).length ? handleCall(item.id, item.phone_no) : setIsOpen(!isOpen))}
                  >
                    <Circle bg="gray.200" size="sm">
                      <Icon size="8" color="green.700" as={<MaterialIcons name="call" />} />
                    </Circle>
                  </TouchableOpacity>
                ) : null}
              </VStack>
            </HStack>
          </Box>
        );
      }}
      keyExtractor={(item: any) => item.id}
    />
  );
};

export default MitrasList;
